import { Component, Vue, Watch } from "vue-property-decorator";
import DataTable, { TableVisibility } from "@/components/data-table/DataTable";
import { Options } from "@/components/mi-dialog/MiDialog";
import { AxiosError } from "axios";
import ErrorHandler from "@/support/ErrorHandler";
import CreateDialog from "@/views/Settings/Suppliers/CreateDialog";
import { Supplier } from "@/models/Supplier";

@Component<Suppliers>({
  components: {
    CreateDialog
  }
})
export default class Suppliers extends Vue {
  protected selectedSupplier: Supplier | null = null;
  protected isCreatingSupplier: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true
  };

  protected mounted() {}

  get tableOptions(): Object {
    return {
      model: new Supplier(),
      name: {
        singular: "Supplier",
        plural: "Suppliers"
      },
      sort: {
        key: "name",
        order: "ASC"
      },
      headers: [
        {
          text: "Name",
          value: "name",
          sortable: {
            key: "name",
            order: "ASC"
          }
        },
        {
          text: "Shortcode",
          value: "short_name",
          sortable: {
            key: "short_name",
            order: "ASC"
          }
        },
        {
          text: "Creditor code",
          value: "creditor_code",
          sortable: {
            key: "creditor_code",
            order: "ASC"
          }
        }
      ],
      actions: [
        {
          type: "edit",
          label: "edit",
          icon: "edit",
          action: (datatable: DataTable, supplier: Supplier) => {
            this.selectedSupplier = supplier;
            this.isCreatingSupplier = true;
          }
        },
        {
          type: "delete",
          label: "delete",
          icon: "delete",
          action: (datatable: DataTable, supplier: Supplier) => {
            this.selectedSupplier = supplier;
            this.$store.dispatch("openDialog", this.dialogOptions);
          }
        }
      ],
      add: () => {
        this.isCreatingSupplier = true;
      }
    };
  }

  protected get suppliersDatatable(): DataTable | null {
    const dataTable = this.$refs.suppliersDatatable;
    if (dataTable) {
      return dataTable as DataTable;
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title:
        (this.selectedSupplier as Supplier).name ||
        'Confirm deletion',
      text: 'Are you sure you wish to delete this supplier?',
      type: "warning",
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedSupplier) {
              return;
            }

            this.selectedSupplier
              .delete()
              .then((response: any) => {
                if (response) {
                  this.suppliersDatatable
                    ? this.suppliersDatatable.refresh(true)
                    : null;
                  this.selectedSupplier = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          }
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedSupplier = null;
          }
        }
      }
    };
  }

  @Watch("isCreatingSupplier")
  protected isCreatingSupplierChanged() {
    if (!this.isCreatingSupplier) {
      this.selectedSupplier = null;
    }
  }
}
